import * as React from "react";
import { AlternativeHotels, InterruptionLink } from "src/typings/microserviceModels/hotels-flex-module";
import { ItemKeyHelper } from "src/components/utility/ItemKeyHelper";
import { UitkSecondaryButton, UitkButtonSize } from "uitk-react-button";
import { LocalizedComponentProps } from "bernie-l10n";
import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { useLocalization } from "@shared-ui/localization-context";
import IsomorphicCarousel from "src/components/shared/IsomorphicCarousel/IsomorphicCarousel";

const HotelInterruptionKeyHelper: ItemKeyHelper = new ItemKeyHelper("hotel-interruption-item");
const ButtonTracked = FlexClickTracker(UitkSecondaryButton);

const SortButton = ({ id, text, url }: InterruptionLink) => {
  return (
    <div className="uitk-cell">
      <ButtonTracked
        text={text}
        className="filterButton"
        tag="a"
        href={url}
        size={UitkButtonSize.LARGE}
        moduleName="Hotels"
        rfrr={`hotelInterruption.sortButton.${id}`}
      />
    </div>
  );
};

interface HotelInterruptionProps extends AlternativeHotels, LocalizedComponentProps {
  isMobile: boolean;
}

/**
 * This component is render in between a card list to encourage the user to further filter the list of elements.
 * Currently only supports the Hotels and the options to further filter them.
 * @param options the alternative Hotel options passed by the parent
 * @param isMobile whether the render viewport is mobile or not
 * @param l10n store for localizations
 */
export const HotelInterruption: React.FC<HotelInterruptionProps> = ({ options, isMobile }) => {
  const { formatText } = useLocalization();

  return options.length ? (
    <div className="HotelInterruptionList uitk-cell all-cell-1-1 all-y-padding-three all-y-margin-three">
      <div className="all-y-margin-three">
        <h2 className="uitk-type-400 uitk-type-bold titleColor">{formatText("hotels.hotelInterruptionList.title")}</h2>
        <p className="uitk-type-paragraph-300">{formatText("hotels.hotelInterruptionList.subtitle")}</p>
      </div>
      <ContainerInterruptionLinks isMobile={isMobile}>
        {options.map((interruptionLink: InterruptionLink) => (
          <SortButton key={HotelInterruptionKeyHelper.next()} {...interruptionLink} />
        ))}
      </ContainerInterruptionLinks>
    </div>
  ) : null;
};

const ContainerInterruptionLinks = ({ isMobile, children }: { isMobile: boolean; children: React.ReactElement[] }) => {
  const { formatText } = useLocalization();

  if (isMobile) {
    const carouselProps = {
      className: "carousel-component",
      itemsVisible: { lg: 2, md: 2, sm: 2 },
      pageBy: 1,
      peekWidth: 10,
      buttonText: {
        nextButton: formatText("carousel.item.next"),
        prevButton: formatText("carousel.item.next"),
      },
    };

    return (
      <div className="all-y-margin-three">
        <IsomorphicCarousel {...carouselProps}>{children}</IsomorphicCarousel>
      </div>
    );
  } else {
    return <ul className="uitk-grid all-cell-1-3 all-x-gutter-three all-y-padding-three">{children}</ul>;
  }
};

export default HotelInterruption;
